import { render, staticRenderFns } from "./IndividualEmployeeLeaveEntitlementTable.vue?vue&type=template&id=5e30a14a&scoped=true&"
import script from "./IndividualEmployeeLeaveEntitlementTable.vue?vue&type=script&lang=js&"
export * from "./IndividualEmployeeLeaveEntitlementTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e30a14a",
  null
  
)

export default component.exports